export enum LocationType {
  ORIGIN = "origin",
  DESTINATION = "destination"
}